export default __webpack_public_path__ + "static/media/damilola.b5dd6913.png";